import { useEffect, useState } from "react";
import TopNav from "@/components/pathway/TopNav";
import PositioningStrip from "@/components/pathway/PositioningStrip";
import Hero from "@/components/pathway/Hero";
import OperationalMission from "@/components/pathway/OperationalMission";
import DisclaimerBanner from "@/components/pathway/DisclaimerBanner";
import GovernanceCentre from "@/components/pathway/GovernanceCentre";
import WorkflowDiagram from "@/components/pathway/WorkflowDiagram";
import PlatformBoundaries from "@/components/pathway/PlatformBoundaries";
import OperationalDebt from "@/components/pathway/OperationalDebt";
import Journey from "@/components/pathway/Journey";
import Themes from "@/components/pathway/Themes";
import ReferenceScenario from "@/components/pathway/ReferenceScenario";
import CyberSample from "@/components/pathway/CyberSample";
import ThoughtLeadershipAndOutputs from "@/components/pathway/ThoughtLeadershipAndOutputs";
import AdoptionPath from "@/components/pathway/AdoptionPath";
import IntakeForm from "@/components/pathway/IntakeForm";
import Footer from "@/components/pathway/Footer";
import ReceiptModal from "@/components/pathway/ReceiptModal";
import { RuntimeProvider, useRuntime } from "@/lib/RuntimeContext";
import {
  conflictingInstructionsReceipt,
  cyberSampleReceipt,
  downloadJson,
} from "@/lib/receipt";

export default function InsurancePathway() {
  return (
    <RuntimeProvider>
      <InsurancePathwayInner />
    </RuntimeProvider>
  );
}

function InsurancePathwayInner() {
  const { status: runtime } = useRuntime();
  const [receipt, setReceipt] = useState(null);

  useEffect(() => {
    if (typeof document === "undefined") return;
    document.body.style.overflow = receipt ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [receipt]);

  const onCyber = () => setReceipt(cyberSampleReceipt(runtime));
  const onScenario = () => setReceipt(conflictingInstructionsReceipt(runtime));
  const onClose = () => setReceipt(null);
  const onDownload = () => {
    if (!receipt) return;
    downloadJson(
      `lab-pathway-receipt-${receipt.reference}.json`,
      receipt
    );
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-neutral-100">
      <TopNav />
      <PositioningStrip />
      <Hero />
      <OperationalMission />
      <DisclaimerBanner />
      <GovernanceCentre />
      <WorkflowDiagram />
      <PlatformBoundaries />
      <OperationalDebt />
      <Journey />
      <Themes />
      <ReferenceScenario onGenerateReceipt={onScenario} />
      <CyberSample onGenerateReceipt={onCyber} />
      <ThoughtLeadershipAndOutputs />
      <AdoptionPath />
      <IntakeForm />
      <Footer />

      <ReceiptModal
        receipt={receipt}
        onClose={onClose}
        onDownload={onDownload}
      />
    </div>
  );
}
